import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { SiteLogo } from '../components/SiteLogo';
import { WeddingVideos } from '../components/thankyou/WeddingVideos';
import { ReviewsWall } from '../components/thankyou/ReviewsWall';
import { FollowUs } from '../components/thankyou/FollowUs';
export function ThankYou() {
  useEffect(() => {
    document.title = 'You’re confirmed — Twenty Mile House';
  }, []);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-140" data-mp="2xrhi5sevzxqv">
      <header className="relative flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-141" data-mp="2xpy0bxdl1emz">
        <SiteLogo size="sm" data-id="element-142" data-mp="32ir52l91wmz2" />
        <Link to="/bay-area" className="absolute right-6 font-sans text-[10px] font-medium uppercase tracking-[0.25em] text-ink/60 transition-colors duration-150 hover:text-ink md:right-10" data-id="element-143" data-mp="32kk3xedfa2wi">
          Return to site
        </Link>
      </header>

      <main data-id="element-144" data-mp="3hfqac2gfk3qd">
        <section className="mx-auto max-w-xl px-6 pt-12 text-center" data-id="element-145" data-mp="3hddqtkv0xlb7">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-notice" data-id="element-146" data-mp="287h46i47pe47">
            <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-147" data-mp="238w3yioymufr" />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-light uppercase leading-[1.2] tracking-[0.06em] text-logo md:text-[2.2rem]" data-id="element-148" data-mp="1y7zwxw9bas64">
            You’re booked!
          </h1>
          <p className="mx-auto mt-4 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-149" data-mp="2qv2lbvk9xmin">
            Thank you for scheduling a virtual tour with Twenty Mile House! We can’t wait to show
            you the property and answer your questions.
          </p>
        </section>

        <section className="mx-auto mt-12 max-w-2xl px-6" aria-label="Your tour details" data-id="element-150" data-mp="2d3xrja3l7og8">
          <dl className="grid grid-cols-1 border-y border-ink/10 md:grid-cols-2" data-id="element-151" data-mp="39n53jbckdav0">
            <div className="py-6 text-center md:px-6" data-id="element-152" data-mp="34weyy0bypc1d">
              <dt className="font-display text-2xl text-ink" data-id="element-153" data-mp="34uvhi6ekkuy0">
                What’s <em className="text-gold" data-id="element-154" data-mp="12zo0gfnek8f6">next</em>
              </dt>
              <dd className="mx-auto mt-2 max-w-xs font-body text-[15px] leading-relaxed text-ink/70" data-id="element-155" data-mp="17xg0jwy7b0ug">
                Check your email for your booking confirmation, and add your tour to your calendar
                so you don’t miss it.
              </dd>
            </div>
            <div className="border-t border-ink/10 py-6 text-center md:border-l md:border-t-0 md:px-6" data-id="element-156" data-mp="y5jr5pqnzoax">
              <dt className="font-display text-2xl text-ink" data-id="element-157" data-mp="kahnl99aib1a">
                Need to change your <em className="text-gold" data-id="element-158" data-mp="p5534imbfv3q">time?</em>
              </dt>
              <dd className="mx-auto mt-2 max-w-xs font-body text-[15px] leading-relaxed text-ink/70" data-id="element-159" data-mp="ab8xirhjpgk7">
                You can reschedule or cancel anytime using the link in your confirmation email.
              </dd>
            </div>
          </dl>
        </section>

        <figure className="mx-auto mt-14 max-w-5xl px-6" data-id="element-160" data-mp="29nl5tlzhac1z">
          <img src="https://cdn.magicpatterns.com/uploads/p4QoSscNKtgqFTPhWkJPJF/20231014_Jillian_Marscher_and_Alek_Leckszas_-_Marcella_Laine_Photography_-_Reception_(22).jpg" alt="Long farm tables set for a reception on the brick patio beside the historic Twenty Mile House, under string lights and tall pines" className="aspect-[4/3] w-full object-cover object-top md:aspect-[16/9]" loading="lazy" data-id="element-161" data-mp="29kyz1okew0kt" />
        </figure>

        <section className="mx-auto mt-14 max-w-2xl px-6 text-center" aria-labelledby="before-tour-heading" data-id="element-162" data-mp="gowg530w95dm">
          <h2 id="before-tour-heading" className="font-display text-3xl text-ink" data-id="element-163" data-mp="co2smard5sl9">
            Before your <em className="text-gold" data-id="element-164" data-mp="qnve9ro19imd">tour</em>
          </h2>
          <p className="mx-auto mt-2 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-165" data-mp="loseomqto4ls">
            Explore real weddings and love notes from our couples, so you can start picturing your
            own day here!
          </p>
        </section>

        <div className="mt-14" data-id="element-166" data-mp="2nirthi35l438">
          <WeddingVideos data-id="element-167" data-mp="2oy2s9w2kzwo5" />
          <ReviewsWall data-id="element-168" data-mp="2owsvrbbdmwjm" />
          <FollowUs data-id="element-169" data-mp="2oxkqyl12as9d" />
        </div>
      </main>
    </div>;
}